import { IJsonQuery } from 'packages/JsonQuery';
import { IOffersState, TOffers, EOffersStatus } from 'shared/types/offers';

const defaultRoomsCount = {
  /** Количество четырёхкомнатных квартир **/
  fourRoom: 0,
  /** Количество однокомнатных квартир **/
  oneRoom: 0,
  /** Количество квартир свободной планировки **/
  openPlan: 0,
  /** Количество остальных квартир **/
  other: 0,
  /** Количество студий **/
  studios: 0,
  /** Количество трёхкомнатных квартир **/
  threeRoom: 0,
  /** Всего квартир (любой комнатности) **/
  total: 0,
  /** Количество двухкомнатных квартир **/
  twoRoom: 0,
};

export const initialState: IOffersState<TOffers> = {
  data: {
    jsonQuery: {
      _type: 'flatsale',
    } as IJsonQuery,
    offers: [],
    counters: {
      flatRentCounters: defaultRoomsCount,
      flatSaleCounters: defaultRoomsCount,
      dailyRentCounters: defaultRoomsCount,
      total: 0,
    },
  },
  status: EOffersStatus.Pending,
};
